import { useLang } from "../context/LangContext";
import "../styles/pages/About.css";

const EyeIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="3" />
    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z" />
  </svg>
);

const TargetIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="12" r="6" />
    <circle cx="12" cy="12" r="2" />
  </svg>
);

export default function About() {
  const { dict } = useLang();
  const t = dict?.about ?? {};

  return (
    <section className="about-section page-section" id="about">
      <div className="about-inner">
        <section className="about-intro">
          <h2 className="about-heading">
            <span>{t.titlePrefix}</span>{" "}
            <span className="about-heading-separator">—</span>{" "}
            <span className="about-highlight">{t.brand}</span>
          </h2>

          <p className="about-description">{t.description}</p>

          <div className="about-cards">
            <article className="about-card">
              <div className="about-card-icon">
                <EyeIcon />
              </div>
              <h3 className="about-card-title">{t.visionTitle}</h3>
              <p className="about-card-text">{t.visionText}</p>
            </article>

            <article className="about-card">
              <div className="about-card-icon">
                <TargetIcon />
              </div>
              <h3 className="about-card-title">{t.missionTitle}</h3>
              <p className="about-card-text">{t.missionText}</p>
            </article>
          </div>
        </section>

        <section className="about-what">
          <h2 className="about-what-title">{t.whatWeDoTitle}</h2>
          <p className="about-what-text">{t.whatWeDoText}</p>
        </section>
      </div>
    </section>
  );
}